import { editSenderId, getListOfSenderId } from "../types/sender_id_list_types";

export const getListOfSenderIdRequest = (payload, cb) => ({
  type: getListOfSenderId.GET_LIST_OF_SENDER_ID_REQUEST,
  payload,
  cb,
});
export const getListOfSenderIdSuccess = (payload) => ({
  type: getListOfSenderId.GET_LIST_OF_SENDER_ID_SUCCESS,
  payload,
});
export const getListOfSenderIdError = (payload) => ({
  type: getListOfSenderId.GET_LIST_OF_SENDER_ID_ERROR,
  payload,
});

export const editSenderIdRequest = (payload, cb) => ({
  type: editSenderId.EDIT_SENDER_ID_REQUEST,
  payload,
  cb,
});
export const editSenderIdSuccess = (payload) => ({
  type: editSenderId.EDIT_SENDER_ID_SUCCESS,
  payload,
});
export const editSenderIdError = (payload) => ({
  type: editSenderId.EDIT_SENDER_ID_ERROR,
  payload,
});
